import { escapeRegExp } from "lodash";
import type { ReactNode } from "react";

// Must match WHITESPACE_CHARS in spotflow/spotflow/services/tables/schema.py.
const WHITESPACE = /[ \t\n\r\f\v]+/;

export function highlightText(
  text: string,
  term?: string,
  { tolerant = true }: { tolerant?: boolean } = {}
): ReactNode {
  if (!term) return text;
  const pattern = new RegExp(
    tolerant
      ? term.split(WHITESPACE).map(escapeRegExp).join(WHITESPACE.source)
      : escapeRegExp(term),
    "gi"
  );
  const parts: ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(pattern)) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    parts.push(
      <mark
        key={match.index}
        className="rounded-[2px] bg-yellow-200 text-foreground dark:bg-yellow-700/60"
      >
        {match[0]}
      </mark>
    );
    last = match.index + match[0].length;
  }
  if (parts.length === 0) return text;
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
}
